import React from 'react'
import { PropTypes } from 'prop-types'

const Dropdown = (props) => {
  let itemList = []

  if (props.items != null) {
    itemList = props.items.map(item => (<option key={item.id} value={item.id}>{item.name}</option>))
  }

  return (
    <select
      className="ln-c-select"
      value={props.selectedItemId}
      onChange={props.handleChange}
    >
      <option key="0" value="0" disabled>Please select ...</option>
      {itemList}
    </select>
  )
}

Dropdown.propTypes = {
  selectedItemId: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number.isRequired, name: PropTypes.string.isRequired })).isRequired
}

export default Dropdown



// WEBPACK FOOTER //
// ./src/components/Dropdown/index.jsx